<!--  -->
<template>
  <div class="inspection-dialog" :style="inspectionStyle">
    <div class="dialog-head">
      <span class="close iconfont icon-guanbi" @click="close"></span>
      <div class="title-box">
        <!-- <span class="icon iconfont" :class="'icon-'+type"></span> -->
        <span class="icon iconfont icon-signed"></span>
        <span class="title">{{title}}</span>
      </div>
    </div>
    <component :is="changContent"></component>
  </div>
</template>

<script>
import Singned from "./child/singned";
import DelaySingned from "./child/delaySigned";
import AppliedAsSingle from "./child/appliedAsSingle";
import TasktingSigned from "./child/tasktingSigned";
import EditorDelay from "./child/editorDelay";

export default {
  name: "inspectionDialog",
  data() {
    return {
      titleObj: {
        callRepairNSigned: "簽核1", // Inspection repair request - unprocessed approval
        callRepairPSigned: "簽核2", // Inspection repair request - processing approval
        appliedAsSigned: "施作單", // Work order approval
        delaySigned: "延後完成日簽核", // Delayed completion date approval
        appliceCallSigned: "签核2", // From work order to approval 2
        tasktingSigned: "回饋施作單內容", // Work assignment approval
        editorDelay: "修改延后完成日" // Edit delayed completion date
      }
    };
  },
  // inspection/set-ass-category
  components: {
    Singned,
    AppliedAsSingle,
    DelaySingned,
    EditorDelay
  },

  methods: {
    close() {
      this.$store.commit("SET_IS_SHOW_DIALOG");
    }
  },

  computed: {
    dialogType() {
      return this.$store.state.dialogType;
    },
    changContent() {
      // this[this.dialogType]()
      if (this.dialogType == "appliedAsSigned") {
        // Work order
        return AppliedAsSingle;
      } else if (this.dialogType == "delaySigned") {
        // Delayed completion date approval
        return DelaySingned;
      } else if (this.dialogType == "tasktingSigned") {
        // Work assignment overview approval
        return TasktingSigned;
      } else if (this.dialogType == "editorDelay") {
        // Approval
        return EditorDelay;
      } else {
        // Approval
        return Singned;
      }
    },
    title() {
      return this.titleObj[this.dialogType];
    },
    inspectionStyle() {
      if (
        this.dialogType != "appliedAsSigned" &&
        this.dialogType != "editorDelay"
      ) {
        return "width:90rem;";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.inspection-dialog {
  position: absolute;
  left: 50%;
  top: 50%;
  // width: 1338px;
  transform: translate(-50%, -50%);
  border-radius: 15px;
  background: #fff;
  padding: 40px 57px;
  // width: 85rem;
  // height: 60rem;
  .dialog-head {
    .close {
      position: absolute;
      right: -1.6rem;
      top: -1.6rem;
      display: inline-block;
      width: 3.2rem;
      height: 3.2rem;
      color: #44484c;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0px 0px 10px #ccc;
      font-size: 1.4rem;
      font-weight: 900;
      text-align: center;
      line-height: 3.2rem;
      cursor: pointer;
    }
    .icon {
      font-size: 30px;
      color: #587ee0;
      margin-right: 15px;
    }
    .title-box {
      .title {
        font-size: 30px;
        color: #587ee0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/inspectionDialogContent/inspectionDialog.vue